export const FORM_CONSTANTS = {
  BREADCRUMB: {
    TITLE: "CM3/PM Quarterly Bonus Form",
    PATH: "/bonus/form/cm3pm",
  },
  HEADER: {
    TITLE: "Quarterly Bonus",
    SUBTITLE:
      "Achievement of Targets is a subjective determination in the Employer's sole discretion. The Employer may change the percentages or Targets at any time.",
  },
  LAYOUT: {
    MAX_WIDTH: "max-w-9xl",
    PADDING: "px-4 sm:px-6 lg:px-8",
  },
  SECTIONS: {
    OPERATIONAL_EFFICIENCY: {
      TITLE: "OPERATIONAL EFFICIENCY",
      COLOR: "bg-orange-500",
      SUBSECTIONS: {
        COMMUNITY_PRODUCTION: {
          TITLE: "Community Production",
          WEIGHT: "35% of total achievement score",
          NOTE: "Earning 70%-120% of Benchmark",
        },
        EXTRA_LABOR: {
          TITLE: "Extra Labor and Material",
          WEIGHT: "15% of total achievement score",
          NOTE: "This will be evaluated from monthly financial reports.",
        },
        CUSTOMER_CARE: {
          TITLE: "Customer Care Expense",
          WEIGHT: "10% of total achievement score",
          NOTE: "This will be evaluated from monthly financial reports. The goal is at or below customer care budget.",
        },
      },
    },
    CUSTOMER_EXPERIENCE: {
      TITLE: "CUSTOMER EXPERIENCE",
      COLOR: "bg-orange-500",
      SUBSECTIONS: {
        CARE_CALLS: {
          TITLE: "Customer Care Calls",
          WEIGHT: "20% of total achievement score",
          NOTE: "This will be evaluated from calls completed within 7 days. The goal is 70% of all calls completed within 7 days.",
        },
      },
    },
    BONUS_CALCULATION: {
      TITLE: "BONUS CALCULATION",
      COLOR: "bg-orange-500",
    },
  },
  FORM_TYPES: [
    { value: "CM3/PM", label: "CM3/PM" },
    { value: "CCM", label: "CCM" },
    { value: "DCCM", label: "DCCM" },
    { value: "SPM", label: "SPM" },
  ],
  OPS: {
    NAME: "Angie Hayes",
    EMAIL: "Angie.Hayes@highlandhomes.com",
  }
};
